<template>
  <section id="ceo">
    <h5>
      CEO´s comments
    </h5>

    <div class="ceo-img-continaer">
      <img src="../assets/img/ceo2.png">
    </div>

    <scroll-view :offset="100">
      <template slot-scope="visibility">
        <c-box key="box"
               :visible="visibility.box"/>
      </template>
    </scroll-view>
  </section>
</template>

<script>
  import CBox from '../components/Box.vue';

  export default {
    name: 'Ceo',
    components: {
      CBox
    }
  }
</script>



// WEBPACK FOOTER //
// src/sections/Ceo.vue